import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const ChevronRightRoundedIcon: React.FC<SvgIconProps> = ({sx, fontSize}) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.WHITE,
      ...sx,
    }}
    fontSize={fontSize}
  >
    <path 
      d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
)
